import { TipsMapType } from '../index';

export const separateByCountryPCTips: TipsMapType = {
  en: `User Score includes Steam All Reviews Positive%、Steam Selected Reviews Positive%、OpenCritic Score、MetaCritic Score, etc. And the lifetime OpenCritic Score、MetaCritic Score cannot be split by language as they are directly scraped from the website's score.`,
  zh: '用户评分包括Steam所选时段评论正面占比、Steam累计评论正面占比、OpenCritic累计评分、MetaCritic累计评分等。其中累计评分由于直接爬取至网站得分，无法按语种拆分。',
};

export const separateByCountryConsoleTips: TipsMapType = {
  en: `User Scores by language are not supported`,
  zh: '暂不支持按语种显示商店用户评分',
};

export const separateByCountryMobileTips: TipsMapType = {
  en: `User Scores by language are not supported`,
  zh: '暂不支持按语种显示商店用户评分',
};

export const separateReviewsRatingTips: TipsMapType = {
  en: `User Score download template already contains split by ratings`,
  zh: 'User Score下载模板已包含按商店评论评分进行拆分',
};
